import { createSelector, OutputSelector } from 'reselect'
import { Genre } from 'Types/index'
import { createDeepEqualSelector } from 'Redux/selectors/index'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getState = (state: { genres: any }) => state.genres

// @ts-ignore
export const getGenres: OutputSelector<
  [],
  Array<Genre>,
  (res: unknown) => unknown
> = createDeepEqualSelector(getState, ({ genres }) => genres)

export const getAutoselectedGenres = createSelector(
  getState,
  ({ autoselectedGenres }) => autoselectedGenres
)

export const getMaxCuratorsInGenres = createSelector(
  getState,
  ({ max_curators }) => max_curators
)

export const playlistsForGenre = createSelector(
  getState,
  ({ playlists_count }) => playlists_count
)
